// Fetch data attributes
const offerDiscount = document.getElementById('discounted-price')?.getAttribute('data-offer-discount') * 0.1;
const productPrice = parseFloat(document.getElementById('discounted-price')?.getAttribute('data-product-price')) / 100;
const savedAmount = Math.round(productPrice * (0.1 * offerDiscount));
const discountedPrice = productPrice - savedAmount;

// Update the discount-off element
const discountOffElement = document.querySelector('.discount-off');
if (discountOffElement) {
    discountOffElement.textContent = '₹' + savedAmount.toFixed(2); // Display saved amount
}
const finalPriceElement = document.querySelector('.final-price');
if (finalPriceElement) {
    finalPriceElement.innerHTML = `Get it for ₹<strong>${discountedPrice}</strong>`; // Display discounted price in bold
}

const copyTextElements = document.querySelectorAll('.copy-text-value');
const copyMessage = document.getElementById('copyMessages');

copyTextElements.forEach(element => {
    element.addEventListener('click', () => {
        const copiedText = element.getAttribute('data-copied-value');

        // Create a temporary textarea to copy the text
        const textarea = document.createElement('textarea');
        textarea.value = copiedText;
        document.body.appendChild(textarea);

        // Copy the text from textarea
        textarea.select();
        document.execCommand('copy');

        document.body.removeChild(textarea);
        copyMessage.style.display = 'block';

        setTimeout(() => {
            copyMessage.style.display = 'none';
        }, 1000);
    });
});